import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Table,
  Divider,
  message,
  DatePicker,
  Select,
} from "antd";
import { fetchTakeOutList } from "../../../api/takeOut";
import NProgress from "nprogress";
const { Column } = Table;

const { Option } = Select;
const { RangePicker } = DatePicker;

const BreadCrumbData = [
  { path: "/page/dataanalysis/dataanalysis", name: "数据分析" },
  { path: "", name: "外卖订单记录" },
];
const options = [
  {
    label: "待确认",
    value: "1",
  },
  {
    label: "已确认",
    value: "5",
  },
  {
    label: "骑士已接单",
    value: "7",
  },
  {
    label: "骑士已取餐",
    value: "8",
  },
  {
    label: "已完成",
    value: "9",
  },
  {
    label: "已取消",
    value: "10",
  },
  {
    label: "订单退款",
    value: "15",
  },
];

const renderOptions = () => {
  return options.map((item) => (
    <Option key={item.value} value={item.value}>
      {item.label}
    </Option>
  ));
};

let accessToken = JSON.parse(sessionStorage.getItem("loginInfo"))
  ? JSON.parse(sessionStorage.getItem("loginInfo")).accessToken
  : "";
class TakeOutOrderRecord extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      beginTime: "",
      endTime: "",
      status: "",
      orderId: "",
      companyName: "",
    },
    list: [],
    total: 0,
    totalPrice: 0,
  };
  async componentDidMount() {
    NProgress.start();
    await this.getList();
    NProgress.done();
  }
  getList = () => {
    let listQuery = { ...this.state.listQuery };
    let temp = Object.keys(listQuery);
    temp.forEach((item) => {
      if (listQuery[item] === "") {
        delete listQuery[item];
      }
    });
    fetchTakeOutList(listQuery).then((res) => {
      if (res.success) {
        this.setState({
          list: res.data.searchResult.list,
          total: res.data.searchResult.total,
          totalPrice: res.data.totalPrice,
        });
      }
    });
  };
  dateChange = (date, dateString) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };
  handleChange = (e) => {
    const { listQuery } = this.state;
    switch (e.target.name) {
      case "orderId":
        this.setState({
          listQuery: { ...listQuery, orderId: e.target.value },
        });
        break;
      case "companyName":
        this.setState({
          listQuery: { ...listQuery, companyName: e.target.value },
        });
        break;
    }
  };
  handleSelectChange = (value, e) => {
    if (e === "refundStatus") {
      this.setState({
        listQuery: { ...this.state.listQuery, refundStatus: value },
      });
    } else if (e === "status") {
      this.setState({
        listQuery: { ...this.state.listQuery, status: value },
      });
    }
  };
  // handleSelectChange1 = (value) => {
  //   this.setState({
  //     listQuery: { ...this.state.listQuery, refundStatus: value },
  //   });
  // };
  //搜索
  handleSearch = () => {
    this.setState(
      {
        listQuery: { ...this.state.listQuery, pageNum: 1 },
      },
      () => {
        this.getList();
      }
    );
  };
  handleExport = () => {
    let tempQuery = { ...this.state.listQuery };
    let temp = Object.keys(tempQuery);
    let str = "";
    temp.forEach((item) => {
      if (tempQuery[item] !== "") {
        if (item !== "pageNum" && item !== "pageSize") {
          str += item + "=" + tempQuery[item] + "&";
        }
      }
    });
    window.location.href =
      process.env.REACT_APP_API_PREFIX +
      `elemeOrder/export?${str}accessToken=${accessToken}`;
    message.success("导出成功");
  };
  render() {
    const { list, listQuery, total, totalPrice } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="searchTitle">
          <Row>
            <Col span={22}>
              <RangePicker
                onChange={this.dateChange}
                style={{ width: 250, marginRight: 10 }}
              />
              <Input
                style={{ width: 180, marginRight: 10 }}
                placeholder="商户名称"
                allowClear
                name="companyName"
                onChange={this.handleChange}
              />
              <Input
                style={{ width: 200, marginRight: 10 }}
                placeholder="订单编号"
                allowClear
                name="orderId"
                onChange={this.handleChange}
              />
              <Select
                allowClear
                placeholder="订单状态"
                name="status"
                style={{ width: 120, marginRight: 10 }}
                onChange={(value) => this.handleSelectChange(value, "status")}
              >
                {renderOptions()}
              </Select>
              <Select
                allowClear
                placeholder="退款状态"
                style={{ width: 120, marginRight: 10 }}
                onChange={(value) =>
                  this.handleSelectChange(value, "refundStatus")
                }
              >
                <Option key={0} value={0}>
                  未发生退款
                </Option>
                <Option key={1} value={1}>
                  全部退款
                </Option>
                <Option key={2} value={2}>
                  部分退款
                </Option>
              </Select>

              <Button type="primary" onClick={this.handleSearch}>
                搜索
              </Button>
            </Col>
            <Col span={2} align="right">
              <Button type="primary" onClick={this.handleExport}>
                导出
              </Button>
            </Col>
          </Row>
        </div>
        <div className="content">
          <Table
            dataSource={list}
            footer={() => (
              <div style={{ textAlign: "right", paddingRight: 20 }}>
                实收总额：￥{totalPrice}
              </div>
            )}
            rowKey="orderId"
            pagination={{
              showTotal: () => `共${total}条`,
              total: total,
              pageSize: listQuery.pageSize,
              current: listQuery.pageNum,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageNum: page },
                  },
                  () => this.getList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageSize, pageNum: 1 },
                  },
                  () => this.getList()
                );
              },
            }}
          >
            <Column title="时间" dataIndex="createTime" key="createTime" />
            <Column title="商户名称" dataIndex="shopName" key="shopName" />
            <Column title="订单编号" dataIndex="orderId" key="orderId" />
            <Column
              title="订单状态"
              dataIndex="status"
              key="status"
              render={(value) => {
                switch (value) {
                  case 1:
                    return <div>待确认</div>;
                    break;
                  case 5:
                    return <div>已确认</div>;
                    break;
                  case 7:
                    return <div>骑士已接单</div>;
                    break;
                  case 8:
                    return <div>骑士已取餐</div>;
                    break;
                  case 9:
                    return <div>已完成</div>;
                    break;
                  case 10:
                    return <div>已取消</div>;
                    break;
                  case 15:
                    return <div>订单退款</div>;
                    break;
                }
              }}
            />
            <Column
              title="退款状态"
              dataIndex="refundStatus"
              key="refundStatus"
              render={(value) => {
                switch (value) {
                  case 0:
                    return null;
                    break;
                  case 1:
                    return "全部退款";
                    break;
                  case 2:
                    return "部分退款";
                    break;
                  default:
                    return null;
                }
              }}
            />
            <Column
              title="订单金额"
              dataIndex="totalFee"
              key="totalFee"
              render={(value) => value / 100}
            />
            <Column
              title="实收金额"
              dataIndex="actualFee"
              key="actualFee"
              render={(value) => value / 100}
            />
            {/* <Column
              title="退单状态"
              dataIndex="refundStatus"
              key="refundStatus"
              render={(value) => {
                switch (value) {
                  case "noRefund":
                    return <div>未申请退单</div>;
                    break;
                  case "applied":
                    return <div>用户申请退单</div>;
                    break;
                  case "rejected":
                    return <div>店铺拒绝退单</div>;
                    break;
                  case "arbitrating":
                    return <div>客服仲裁中</div>;
                    break;
                  case "failed":
                    return <div>退单失败</div>;
                    break;
                  case "successful":
                    return <div>退单成功</div>;
                    break;
                }
              }}
            /> */}
            <Column
              title="操作"
              render={(value) => {
                return (
                  <a
                    href="javascript:;"
                    onClick={() =>
                      this.props.history.push(
                        `/page/dataanalysis/TakeOutOrderRecordDetail/${value.orderId}`
                      )
                    }
                  >
                    查看详情
                  </a>
                );
              }}
            />
          </Table>
        </div>
      </div>
    );
  }
}
export default TakeOutOrderRecord;
